import { styled } from '@mui/material/styles';
import { Select } from '@mui/material';

export const StyledSelect = styled(Select)(({ theme }) => ({
    '&& .MuiSelect-outlined': {
        width: '390px',
        zIndex: 2000,
        height: '29px',
        borderRadius: 4,
        fontSize: 14,
        padding: '12px',
        display: 'flex',
        alignItems: 'center'
    },

    '& .MuiSelect-icon': {
        zIndex: 100,
        width: '24px',
        height: 'auto',
        top: '25%'
    }
}));
